"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreatePixelRequest1ToJSON = exports.CreatePixelRequest1FromJSONTyped = exports.CreatePixelRequest1FromJSON = exports.instanceOfCreatePixelRequest1 = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the CreatePixelRequest1 interface.
 */
function instanceOfCreatePixelRequest1(value) {
    var isInstance = true;
    isInstance = isInstance && "domain" in value;
    isInstance = isInstance && "name" in value;
    return isInstance;
}
exports.instanceOfCreatePixelRequest1 = instanceOfCreatePixelRequest1;
function CreatePixelRequest1FromJSON(json) {
    return CreatePixelRequest1FromJSONTyped(json, false);
}
exports.CreatePixelRequest1FromJSON = CreatePixelRequest1FromJSON;
function CreatePixelRequest1FromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'domain': json['domain'],
        'name': json['name'],
        'datasetId': !(0, runtime_1.exists)(json, 'dataset_id') ? undefined : json['dataset_id'],
    };
}
exports.CreatePixelRequest1FromJSONTyped = CreatePixelRequest1FromJSONTyped;
function CreatePixelRequest1ToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'domain': value.domain,
        'name': value.name,
        'dataset_id': value.datasetId,
    };
}
exports.CreatePixelRequest1ToJSON = CreatePixelRequest1ToJSON;
